import { useTranslation } from 'react-i18next';
import { AppButton, AppContainer } from '../../components';
import ToggleText from './components/ToggleText';
import FacebookPixel from 'react-facebook-pixel';
import TiktokPixel from 'tiktok-pixel';
import {
  AppLogo,
  HeaderAppName,
  HeaderAppText,
  HeaderAppValue,
  HeaderDesignedText,
  HeaderFreeText,
  HeaderInfoText,
  HeaderRatingWrapper,
  HeaderSmallDot,
  HeaderStars,
  HeaderTextWrapper,
  HeaderWrapper,
  LogoWrapper,
  Separator,
  MainTitle,
  RatingWrapper,
  StarsLinesWrapper,
  RatingValue,
  RatingLinesImg,
  RatingStarsImg,
  ValuesWrapper,
  PrivacyText,
  DataWrapper,
  DataItemImg,
  DataItem,
  DataItemDescription,
  DataItemTitle,
  DataFeatureWrapper,
  DataFeatureImg,
  DataFeatureText,
  DataImgWrapper,
  PrivacySubText,
  FamilySharingWrapper,
  FamilySharingImg,
  FamilySharingText,
  Links,
  Linkbutton,
  StyledDisclaimer,
} from './styled';
import {
  FB_PIXEL_ID,
  FBC_PARAM,
  FBP_PARAM,
  TIKTOK_PIXEL_ID,
  TIKTOK_TTP,
} from '../../constants';
import { useEffect, useMemo, useState } from 'react';
import ScreenshotSlider from './components/ScreenshotSlider';
import ReviewSlider from './components/ReviewSlider';
import { queryParser, concatClickID } from '../../helper';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';

const StoreScreen = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const oneLinkInitial = 'https://family-locator.onelink.me/eb3y';
  const [oneLinkUrl, setOneLinkUrl] = useState(oneLinkInitial);
  const [eventParams, setEventParams] = useState(null);
  const [currentPixel, setCurrentPixel] = useState(null);
  const fbc = Cookies.get(FBC_PARAM) || '';
  const fbp = Cookies.get(FBP_PARAM) || '';
  const ttp = Cookies.get(TIKTOK_TTP) || '';
  const afUserId = Cookies.get('afUserId') || '';
  const pixelsParams = useMemo(
    () => ({
      pixel: {
        facebook: FacebookPixel,
        tiktok: TiktokPixel,
      },
      pixelId: {
        facebook: FB_PIXEL_ID,
        tiktok: TIKTOK_PIXEL_ID,
      },
      sub2: {
        facebook: 'fbclid',
        tiktok: 'ttclid',
      },
      cookie: {
        facebook: concatClickID(fbc, fbp, afUserId),
        tiktok: concatClickID('', ttp, afUserId),
      },
    }),
    [fbc, fbp, ttp, afUserId]
  );

  useEffect(() => {
    if (eventParams) return;
    const { fbclid, ttclid, deep_link_value, ...utms } = queryParser(
      location.search
    );
    const {
      utm_medium,
      utm_campaign,
      utm_content,
      Adset_name,
      Ad_name,
      CampaignID,
      AdSetID,
      AdID,
    } = utms;
    const facebookUtm = fbclid ? 'facebook' : null;
    const utmSource = utms['utm_source'] || facebookUtm || 'organic';
    utms['utm_source'] = utmSource;
    const searchParams = {
      fbclid: fbclid,
      utm: utms,
      utm_source: utmSource,
      utm_medium,
      utm_campaign,
      utm_content,
      Adset_name,
      Ad_name,
      CampaignID,
      AdSetID,
      AdID,
      deep_link_value,
    };

    const clickIdName = fbclid ? 'facebook' : 'tiktok';
    setCurrentPixel(clickIdName);
    setEventParams(searchParams);
  }, [eventParams, location]);

  useEffect(() => {
    FacebookPixel.init(FB_PIXEL_ID);
    FacebookPixel.pageView();
    TiktokPixel.init(TIKTOK_PIXEL_ID);
    TiktokPixel.pageView();
    TiktokPixel.track('ViewContent', { content_id: 'fl_web2app' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (eventParams && currentPixel) {
      const resultLink = window?.AF_SMART_SCRIPT?.generateOneLinkURL({
        oneLinkURL: oneLinkInitial,
        afParameters: {
          mediaSource: {
            keys: ['utm_source', 'af_pid'],
            defaultValue: `${eventParams.utm.utm_source || ''}`,
          },
          campaign: {
            keys: ['utm_campaign', 'af_c'],
            defaultValue: `${
              eventParams.utm_campaign || eventParams.utm.utm_campaign || ''
            }`,
          },
          channel: {
            keys: ['AdChannel', 'utm_medium', 'af_channel'],
            defaultValue: `${eventParams.utm_medium || ''}`,
          },
          ad: {
            keys: ['utm_ad', 'af_ad', 'AdName'],
            defaultValue: `${eventParams.utm.af_af || ''}`,
          },
          adSet: {
            keys: ['utm_content' || 'af_adset', 'AdSetName'],
            defaultValue: `${eventParams.utm.af_adset || ''}`,
          },
          deepLinkValue: {
            keys: ['deep_link_value'],
            defaultValue: `${eventParams.deep_link_value || ''}`,
          },
          afSub1: { keys: ['af_sub1'], defaultValue: '' },
          afSub2: {
            keys: ['af_sub2', pixelsParams.sub2[currentPixel]],
            defaultValue: '',
          },
          afSub3: {
            keys: ['af_sub3'],
            defaultValue: pixelsParams.pixelId[currentPixel],
          },
          afSub4: {
            keys: ['af_sub4'],
            defaultValue: pixelsParams.cookie[currentPixel],
          },
          afSub5: {
            keys: ['af_sub5'],
            defaultValue: encodeURI(window.navigator.userAgent),
          },
        },
      });
      // console.log(resultLink);
      setOneLinkUrl(`${resultLink?.clickURL}&af_dp=family-locator-webtoapp://`);
    }
  }, [eventParams, pixelsParams, currentPixel]);

  const onLinkClick = (url) => window.open(url);

  const onAnyElementClick = () => {
    pixelsParams.pixel[currentPixel].track('AddToCart', {
      content_id: 'fl_web2app',
    });
    setTimeout(() => (window.location.href = oneLinkUrl), 1000);
  };

  const cardsContent = useMemo(
    () => [
      {
        id: 1,
        itemPath: '../assets/track/identify.png',
        title: t('card1_title'),
        description: t('card1_description'),
        dataImages: [
          {
            id: 1,
            featurePath: '../assets/track/financial.png',
            featureText: t('financial_info'),
          },
          {
            id: 2,
            featurePath: '../assets/track/contact.png',
            featureText: t('contact_info'),
          },
          {
            id: 3,
            featurePath: '../assets/track/identifiers.png',
            featureText: t('identifiers'),
          },
          {
            id: 4,
            featurePath: '../assets/track/usage.png',
            featureText: t('usage_data'),
          },
        ],
      },
      {
        id: 2,
        itemPath: '../assets/data-linked/user-icon.png',
        title: t('card2_title'),
        description: t('card2_description'),
        dataImages: [
          {
            id: 1,
            featurePath: '../assets/data-linked/contact.png',
            featureText: t('contact_info'),
          },
        ],
      },
      {
        id: 3,
        itemPath: '../assets/data-not-linked/crossed-user.png',
        title: t('card3_title'),
        description: t('card2_description'),
        dataImages: [
          {
            id: 1,
            featurePath: '../assets/data-not-linked/financial.png',
            featureText: t('financial_info'),
          },
          {
            id: 2,
            featurePath: '../assets/data-not-linked/location.png',
            featureText: t('location'),
          },
          {
            id: 3,
            featurePath: '../assets/data-not-linked/contact.png',
            featureText: t('contact_info'),
          },
          {
            id: 4,
            featurePath: '../assets/data-not-linked/user-content.png',
            featureText: t('user_content'),
          },
          {
            id: 5,
            featurePath: '../assets/data-not-linked/identifiers.png',
            featureText: t('identifiers'),
          },
          {
            id: 6,
            featurePath: '../assets/data-not-linked/usage.png',
            featureText: t('usage_data'),
          },
          {
            id: 7,
            featurePath: '../assets/data-not-linked/diagnostics.png',
            featureText: t('diagnostics'),
          },
        ],
      },
    ],
    [t]
  );
  const reviewsContent = useMemo(
    () => [
      {
        id: 1,
        reviewer: 'meggyatbest',
        text: t('reviewer1'),
      },
      {
        id: 2,
        reviewer: 'kevinpeters90',
        text: t('reviewer2'),
      },
      {
        id: 3,
        reviewer: 'johnlee75',
        text: t('reviewer3'),
      },
    ],
    [t]
  );
  const renderDataItem = (item, index) => (
    <DataItem key={item.id || index}>
      <DataItemImg src={item.itemPath} alt={item.title} />
      <DataItemTitle>{item.title}</DataItemTitle>
      <DataItemDescription>{item.description}</DataItemDescription>
      <DataImgWrapper>
        {item.dataImages.map((i, index) => (
          <DataFeatureWrapper key={index}>
            <DataFeatureImg src={i.featurePath} />
            <DataFeatureText>{i.featureText}</DataFeatureText>
          </DataFeatureWrapper>
        ))}
      </DataImgWrapper>
    </DataItem>
  );

  return (
    <AppContainer>
      <HeaderWrapper>
        <LogoWrapper>
          <AppLogo
            src="../assets/app-logo.png"
            alt={t('app_logo')}
            onClick={onAnyElementClick}
          />
        </LogoWrapper>
        <HeaderTextWrapper>
          <HeaderAppName>
            {t('find_phone')}
            <span>4+</span>
          </HeaderAppName>
          <HeaderInfoText>{t('gps_tracker')}</HeaderInfoText>
          <HeaderAppText>{t('family_locator_llc')}</HeaderAppText>
          <HeaderDesignedText>{t('designed')}</HeaderDesignedText>
          <HeaderRatingWrapper>
            <HeaderStars
              src="../assets/small-stars.png"
              alt={t('stars_review')}
            />
            <HeaderAppValue>4.4</HeaderAppValue>
            {HeaderSmallDot}
            <HeaderAppValue>{t('value_rating')}</HeaderAppValue>
          </HeaderRatingWrapper>
          <HeaderFreeText>{t('free')}</HeaderFreeText>
          <AppButton onClick={onAnyElementClick} />
        </HeaderTextWrapper>
      </HeaderWrapper>
      <Separator />
      <MainTitle>{t('iphone_screenshots')}</MainTitle>
      <ScreenshotSlider onScreenshootClick={onAnyElementClick} />
      <Separator />
      <StyledDisclaimer
        dangerouslySetInnerHTML={{ __html: t('welcome_disclaimer') }}
        onClick={(e) => {
          if (e.target.id === 'terms') {
            onLinkClick('https://family-locator.com/terms-of-use/');
          }
        }}
      />
      <ToggleText
        shortText={{ __html: t('appDescription_shortText') }}
        longText={{ __html: t('appDescription_longText') }}
      />
      <Separator />
      <MainTitle>{t('whats_new')}</MainTitle>
      <ToggleText
        shortText={{ __html: t('whatsNew_shortText') }}
        longText={{ __html: t('whatsNew_longText') }}
      />
      <Separator />
      <MainTitle>{t('rating_review')}</MainTitle>
      <RatingWrapper>
        <RatingValue>4.4</RatingValue>
        <StarsLinesWrapper>
          <RatingStarsImg
            src="../assets/gray-stars.png"
            alt={t('rating_stars')}
          />
          <RatingLinesImg
            src="../assets/ratings-stars.png"
            alt={t('rating_lines')}
          />
        </StarsLinesWrapper>
      </RatingWrapper>
      <ValuesWrapper>
        <span>{t('out_of')}</span>
        <span>{t('value_rating')}</span>
      </ValuesWrapper>
      <ReviewSlider slideData={reviewsContent} />
      <Separator />
      <MainTitle>{t('app_privacy')}</MainTitle>
      <PrivacyText
        dangerouslySetInnerHTML={{ __html: t('privacy_text') }}
        onClick={() =>
          onLinkClick('https://family-locator.com/privacy-policy/')
        }
      />
      <DataWrapper>{cardsContent.map(renderDataItem)}</DataWrapper>
      <PrivacySubText>{t('privacy_practices')}</PrivacySubText>
      <Separator />
      <MainTitle>{t('information')}</MainTitle>
      <ToggleText
        shortText={{ __html: t('information_shortText') }}
        longText={{ __html: t('information_longText') }}
        isStickyBtn
      />
      <Separator />
      <FamilySharingWrapper>
        <FamilySharingImg
          src="../assets/family-sharing.png"
          alt={t('family_sharing')}
        />
        <FamilySharingText>
          {t('family_sharing')}
          <br />
          {t('some_purchases')}
        </FamilySharingText>
      </FamilySharingWrapper>
      <Links>
        <Linkbutton
          onClick={() =>
            onLinkClick('https://family-locator.com/terms-of-use/')
          }
        >
          {t('terms_of_use')}
        </Linkbutton>
        <Linkbutton
          onClick={() =>
            onLinkClick('https://family-locator.com/privacy-policy/')
          }
        >
          {t('privacy_policy')}
        </Linkbutton>
      </Links>
    </AppContainer>
  );
};

export default StoreScreen;
